import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import * as Yup from 'yup';
import FormInputText from '../../../components/FormInputText';
import { getContactUs, updateContactUs } from "./cmsSlice";

const UpdateContactUS = () => {

    const dispatch = useDispatch();
    const [params, setparams] = useState({
        from: "",
        to: "",
        phone: "",
        email: "",
        address: ""
    });


    useEffect(() => {
        dispatch(getContactUs()).then(data => {
            const { content, email, from_time, phone, to_time } = data.payload.data.contactUs
            setparams({
                from: from_time,
                to: to_time,
                phone: phone,
                email: email,
                address: content
            })

        })
    }, [dispatch]);





    const validationSchema = Yup.object().shape({
        phone: Yup.string().required('*phone is Required'),
        from: Yup.string().required('*From Date is Required'),
        to: Yup.string().required('*To Date is Required'),
        email: Yup.string().required('*Email is Required'),
        address: Yup.string().required('*Address is Required')
    });



    const { values, handleSubmit, touched, errors, handleChange, } = useFormik({
        initialValues: params,
        enableReinitialize: true,
        validationSchema,
        onSubmit: async () => {
            dispatch(updateContactUs(values)).then(data => {
                if (data?.payload?.response_code === 200) {
                    toast.success(data?.payload?.message);
                }
                else {
                    toast.error(data?.payload?.message);
                }
            })
        }

    })





    return (
        <article class="col-lg-9">
            <div class="article-body store-bd-gy">
                <div class="row align-items-center col-rever">
                    <div class="col-sm-12 col-md-12 col-lg-12">
                        <h2 class="head-title">Update Contact Us</h2>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <form onSubmit={handleSubmit} class="form-style">
                            <div class="row">

                                <div class="col-sm-6 col-md-6 col-lg-6">

                                    <FormInputText
                                        placeholder="Enter phone number"
                                        type="text"
                                        image="product.png"
                                        onChange={handleChange}
                                        name="phone"
                                        value={values.phone}
                                        title="Phone - use comma (,) for multiple contacts"
                                    />

                                    <span className="errorMessage">
                                        {touched["phone"] && errors["phone"]}
                                    </span>
                                </div>
                                <div class="col-sm-6 col-md-6 col-lg-6">

                                    <FormInputText
                                        placeholder="Enter email address"
                                        type="text"
                                        image="product.png"
                                        onChange={handleChange}
                                        name="email"
                                        value={values.email}
                                        title="Email - use comma (,) for multiple emails"
                                    />

                                    <span className="errorMessage">
                                        {touched["email"] && errors["email"]}
                                    </span>
                                </div>
                                <div class="col-sm-6 col-md-6 col-lg-6">


                                    <FormInputText
                                        placeholder="Query time from"
                                        type="time"
                                        image="product.png"
                                        onChange={handleChange}
                                        name="from"
                                        value={values.from}
                                        title="Query time From"
                                    />

                                    <span className="errorMessage">
                                        {touched["from"] && errors["from"]}
                                    </span>
                                </div>


                                <div class="col-sm-6 col-md-6 col-lg-6">


                                    <FormInputText
                                        placeholder="Query time to"
                                        type="time"
                                        image="small-cate.png"
                                        onChange={handleChange}
                                        name="to"
                                        value={values.to}
                                        title="Query time to"
                                    />

                                    <span className="errorMessage">
                                        {touched["to"] && errors["to"]}
                                    </span>
                                </div>
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <label>Address</label>
                                        <div class="input-container">
                                            <textarea
                                                onChange={handleChange}
                                                value={values.address}
                                                name="address"
                                                class="textarea-control" rows="7"></textarea>
                                        </div>
                                    </div>
                                    <span className="errorMessage">
                                        {touched["address"] && errors["address"]}
                                    </span>
                                </div>

                                <div class="col-sm-12 col-md-12 col-lg-12 mt-5">
                                    <div class="text-center">
                                        <button type="submit" class="btn btn-save">Save</button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

        </article>
    )
}

export default UpdateContactUS;